// @flow

import buildEntityActions from 'app/entity/utils/buildEntityActions';
import buildEntityApi from 'app/entity/utils/buildEntityApi';
import buildEntitySelectors from 'app/entity/utils/buildEntitySelectors';

// Onboarding
export const type = 'onboarding';

export const api = buildEntityApi(type, '/api/v4/onboardings', undefined, {
  ensureTrailingSlash: true,
});

export const selectors = buildEntitySelectors(type);
export const actions = buildEntityActions(type, selectors, api);
